import React from "react";

export default function NoSnacksFound() {
  return (
    <div className="w-full flex justify-center">
      <span className="text-center text-lg mt-4">
        No Snacks found for this account.
      </span>
    </div>
  );
}
